import { render, staticRenderFns } from "./DataDownloadNotice.vue?vue&type=template&id=1a7d8275&scoped=true"
import script from "./DataDownloadNotice.vue?vue&type=script&lang=js"
export * from "./DataDownloadNotice.vue?vue&type=script&lang=js"
import style0 from "./DataDownloadNotice.vue?vue&type=style&index=0&id=1a7d8275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d8275",
  null
  
)

export default component.exports